// extracted by mini-css-extract-plugin
module.exports = {"root":"Store_root__qE7jG"};